import Vue from 'vue'

const requests = {
  territories: null,
  infrastructure: null,
  source: null,
  borders: null,
  flow: null
}

export default {
  getPriorityRules({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.priorityRules, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setPriorityRules', r.body)
      })
  },
  setPriorityRule({ commit, getters }, rule) {
    return Vue.http
      .post(getters.endpoint.priorityRules, rule, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setPriorityRules', r.body)
      })
  },

  /**
   * Загрузка ОИ для форм настройки привязок.
   * @param {*} param0
   * @param {*} payload
   * @param {Boolean} payload.usePeriod передавать период или нет. Для общего экрана с таблицами, запрашиваем все без периода
   * @returns
   */
  getPriorityInfrastructures({ commit, getters }, { usePeriod = false } = {}) {
    let params = {
      limit: 20000,
      offset: 0,
      fields: 'id,name,terminal,point,rank,treatment_input,treatment_output,user_id,status',
      workspace: getters.workspace,
      version: getters.version
    }

    if (usePeriod) {
      params.period = getters.priorityPeriod
    }

    return Vue.http
      .get(getters.endpoint.infrastructure, {
        params
      })
      .then((r) => {
        r.body.results = r.body.results.map((v) => {
          return {
            ...v,
            treatment_type: v.terminal ? [] : v.treatment_output,
            name: v.name || 'Объект ' + v.id
          }
        })
        commit('setPriorityInfrastructure', r.body.results)
      })
  },
  getPrioritySources({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.separateterritory, {
        params: {
          limit: 200000,
          offset: 0,
          fields: 'id,name,center,treatment_type,user_id',
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit(
          'setPrioritySource',
          r.body.results.map((v) => {
            return {
              ...v,
              name: v.name || 'Выделенная территория ' + v.id
            }
          })
        )
      })
  },
  getPriorityFlows({ commit, getters }, { admLevelId } = {}) {
    let requestParams = {
      workspace: getters.workspace,
      version: getters.version,
      limit: 50000
    }

    //Чтобы получить привязки административных территорий, надо передать уровень административного деления
    if (admLevelId && admLevelId !== '20') {
      requestParams.adm_level = admLevelId
    }

    return Vue.http
      .get(getters.endpoint.priorityFlows, {
        params: requestParams
      })
      .then((r) => {
        const result = r.body
          ? r.body.map((v) => {
              return {
                ...v,
                source: v.territory,
                source_infrastructure: v.source_infrastructure_user_id,
                territory: null,
                source_infrastructure_user_id: null,
                infrastructures: v.infrastructures.map((infr) => {
                  return {
                    ...infr,
                    infrastructure: infr.infrastructure_user_id,
                    treatment_type: parseInt(infr.treatment_type)
                  }
                })
              }
            })
          : []
        commit('setPriorityFlows', result)
      })
  },
  updatePriorityFlow({ commit, getters }, params) {
    if (params.source) {
      params.territory = params.source
    }
    if (params.territory === null) {
      delete params.territory
    }

    delete params.source

    if (params.source_infrastructure) {
      params.source_infrastructure_user_id = params.source_infrastructure
    }
    delete params.source_infrastructure

    params.infrastructures = params.infrastructures.map((v) => {
      v.infrastructure_user_id = v.infrastructure
      delete v.infrastructure
      return v
    })
    return Vue.http
      .post(getters.endpoint.priorityFlows, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const old = getters.priorityFlows.concat([])
        const itemIndex = params.territory
          ? getters.priorityFlows.findIndex((v) => v.source === params.territory && v.period === params.period)
          : getters.priorityFlows.findIndex((v) => v.source_infrastructure === params.source_infrastructure_user_id && v.period === params.period)
        if (r.body[0] && r.body[0].territory) {
          r.body[0].source = r.body[0].territory
          delete r.body[0].territory
        }
        if (r.body[0] && r.body[0].source_infrastructure_user_id) {
          r.body[0].source_infrastructure = r.body[0].source_infrastructure_user_id
          delete r.body[0].source_infrastructure_user_id
        }
        if (r.body[0]) {
          r.body[0].infrastructures = r.body[0].infrastructures.map((infr) => {
            return {
              ...infr,
              infrastructure: infr.infrastructure_user_id
            }
          })
        }
        if (itemIndex > -1) {
          if (!r.body[0]) {
            old.splice(itemIndex, 1)
          } else {
            old[itemIndex] = r.body[0]
          }
        } else if (r.body[0]) {
          old.push(r.body[0])
        }
        commit('setPriorityFlows', JSON.parse(JSON.stringify(old)))
        return r.body[0] || r.body
      })
  },
  updatePriorityFlows({ commit, getters, dispatch }, params) {
    params = {
      links: params.map((v) => {
        const result = {
          period: v.period,
          infrastructures: v.infrastructures.map((infr) => {
            infr.infrastructure_user_id = infr.infrastructure
            delete infr.infrastructure
            return infr
          })
        }
        if (v.source) {
          result.territory = v.source
        }
        if (v.source_infrastructure) {
          result.source_infrastructure_user_id = v.source_infrastructure
        }
        return result
      })
    }
    return Vue.http
      .post(getters.endpoint.updatePriorityFlows, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        dispatch('getPriorityFlows')
      })
  },
  downloadPriorityFlows({ getters, dispatch }) {
    return Vue.http
      .post(getters.endpoint.downloadPriorityFlows, {
        status: 'out_of_turn',
        params: {
          workspace_id: getters.workspace,
          data_version: getters.version
        }
      })
      .then((r) => {
        if (r.body.file) {
          dispatch('getFile', r.body.file)
        }
      })
  },
  getPriorityMapData({ dispatch, getters }) {
    if (getters.priorityMapParams && getters.priorityPeriod) {
      const params = {
        zoom: getters.priorityMapParams.zoom
      }
      if (getters.priorityMapParams.zoom >= getters.settings.bbox_min_zoom) {
        params.square = getters.priorityMapParams.square
      }
      dispatch('getPriorityInfrastructureMap', params)
      dispatch('getPrioritySourceMap', params)
      dispatch('getPriorityFlowMap', params)
      dispatch('getPriorityInactiveSourceMap', params)
      dispatch('getPriorityTerritoriesMap', params)
    }
  },
  getPriorityMapDataByLayoutType({ dispatch, getters }, params) {
    if (getters.priorityMapParams && getters.priorityPeriod) {
      const requestParams = {
        zoom: getters.priorityMapParams.zoom
      }
      if (getters.priorityMapParams.zoom >= getters.settings.bbox_min_zoom) {
        params.square = getters.priorityMapParams.square
      }
      switch (params.type) {
        case 'infrastructure':
          dispatch('getPriorityInfrastructureMap', requestParams)
          break
        case 'source':
          dispatch('getPrioritySourceMap', requestParams)
          break
        case 'inactiveSource':
          dispatch('getPriorityInactiveSourceMap', requestParams)
          break
        case 'flow':
          dispatch('getPriorityFlowMap', requestParams)
          break
        case 'admterritory':
          dispatch('getPriorityTerritoriesMap', requestParams)
          break
      }
    }
  },
  getPriorityInfrastructureMap({ commit, getters, dispatch }, params) {
    commit('setPriorityLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map.infrastructure, {
        params: {
          color: getters.objectLayerSettings.infrastructure.selectedColor,
          workspace: getters.workspace,
          version: getters.version,
          period: getters.priorityPeriod
        },
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'infrastructure' })
        }
      })
      .then((r) => {
        requests.infrastructure = null
        commit('updatePriorityMapData', {
          infrastructure: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },
  getPrioritySourceMap({ commit, getters, dispatch }, params) {
    commit('setPriorityLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map.admterritory, {
        params: {
          ...params,
          adm_level: 20,
          workspace: getters.workspace,
          version: getters.version,
          period: getters.priorityPeriod
        },
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'source' })
        }
      })
      .then((r) => {
        requests.source = null
        commit('updatePriorityMapData', {
          source: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },
  getPriorityInactiveSourceMap({ commit, getters, dispatch }, params) {
    commit('setPriorityLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map.source, {
        params: {
          ...params,
          workspace: getters.workspace,
          version: getters.version,
          period: getters.priorityPeriod
        },
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'inactiveSource' })
        }
      })
      .then((r) => {
        requests.inactiveSource = null
        commit('updatePriorityMapData', {
          inactiveSource: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },
  getPriorityFlowMap({ commit, getters, dispatch }, params) {
    commit('setPriorityLoadingData', 1)
    const requestParams = {
      ...params,
      color: getters.objectLayerSettings.flow.selectedColor || 'default',
      period: getters.priorityPeriod,
      workspace: getters.workspace,
      version: getters.version
    }

    return Vue.http
      .get(getters.endpoint.map.flow, {
        params: requestParams,
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'flow' })
        }
      })
      .then((r) => {
        requests.flow = null
        commit('updatePriorityMapData', {
          flow: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },
  getPriorityTerritoriesMap({ commit, getters, dispatch }, params) {
    commit('setPriorityLoadingData', 1)
    const requestParams = {
      zoom: params.zoom || getters.priorityMapParams.zoom,
      adm_level: 20,
      period: getters.priorityPeriod,
      workspace: getters.workspace,
      version: getters.version
    }
    if (params.square) {
      requestParams.square = params.square
    }
    Vue.http
      .get(getters.endpoint.map.admterritory, {
        params: requestParams,
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'territory' })
        }
      })
      .then((r) => {
        requests.territories = null
        commit('updatePriorityMapData', {
          territories: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },

  loadPriorityBordersMap({ commit, getters, dispatch }) {
    const mapParams = {
      zoom: getters.priorityMapParams.zoom,
      square: getters.priorityMapParams.square
    }
    commit('setPriorityLoadingData', 1)
    Vue.http
      .get(getters.endpoint.map.admterritory, {
        params: {
          ...mapParams,
          period: getters.priorityPeriod,
          workspace: getters.workspace,
          version: getters.version,
          adm_level: 20
        },
        before(request) {
          dispatch('abortPriorityMapRequest', { request, key: 'borders' })
        }
      })
      .then((r) => {
        requests.borders = null
        commit('updatePriorityMapData', {
          borders: r.body
        })
        commit('setPriorityLoadingData', 0)
      })
      .catch((e) => {
        commit('setPriorityLoadingData', 0)
        dispatch('handlePriorityMapErros', e)
      })
  },

  abortPriorityMapRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  },

  handlePriorityMapErros({}, e) {
    if (e.status === 0) {
      return
    }
    throw e
  },

  /**
   * Загрузка ОИ для форм настройки привязок.
   * @param {*} param0
   * @param {*} payload
   * @param {Boolean} payload.usePeriod передавать период или нет. Для общего экрана с таблицами, запрашиваем все без периода
   * @returns
   */
  loadPriorityInfrastructures({ commit, getters }, { periodId }) {
    let params = {
      limit: 20000,
      offset: 0,
      fields: 'id,name,terminal,point,rank,treatment_input,treatment_output,user_id,status',
      workspace: getters.workspace,
      version: getters.version
    }

    if (periodId) {
      params.period = periodId
    }

    return Vue.http
      .get(getters.endpoint.infrastructure, {
        params
      })
      .then((response) => {
        const priorityInfrastructures = response.body.results.map((infrastructureItem) => {
          return {
            ...infrastructureItem,
            treatment_type: infrastructureItem.terminal ? [] : infrastructureItem.treatment_output,
            name: infrastructureItem.name || 'Объект ' + infrastructureItem.id,
            id: infrastructureItem.user_id || infrastructureItem.id
          }
        })
        return priorityInfrastructures
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/priorities/actions.js